module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--3--redeem-61fe5559.png";